import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
      });
    }, 3000);
  };

  const contactInfo = [
    {
      icon: '📧',
      title: 'Email Us For sales related queries',
      info: 'sales@alphatechcloud.in',
      subInfo: 'Professional Support'
    },
      {
      icon: '📧',
      title: 'Email Us For support related queries',
      info: 'support@alphatechcloud.in',
      subInfo: 'Professional Support'
    },
   
    {
      icon: '�',
      title: 'Mobile',
      info: '9871757312,  9013799987',
      subInfo: 'Direct Mobile Contact'
    },
    {
      icon: '�',
      title: 'Visit Us',
      info: 'C-10/189, Sector-5, Rohini',
      subInfo: 'Delhi-110085'
    }
  ];

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-header">
          <h2>Get In Touch</h2>
          <p>Ready to upgrade your temperature monitoring system? Contact us today!</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-cards">
              {contactInfo.map((item, index) => (
                <div key={index} className="contact-card" data-aos="fade-right" data-aos-delay={index * 100}>
                  <div className="contact-icon">
                    <span>{item.icon}</span>
                  </div>
                  <div className="contact-details">
                    <h4>{item.title}</h4>
                    <p className="primary-info">{item.info}</p>
                    <p className="secondary-info">{item.subInfo}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="map-placeholder">
              <div className="map-content">
                <h4>🗺️ Our Location</h4>
                <p>Located in Rohini, Delhi. Contact us for appointments and consultations.</p>
                <div className="map-features">
                  <span>🚗 Easy Access</span>
                  <span>🚇 Metro Nearby</span>
                  <span>☕ Professional Service</span>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <div className="contact-form-container">
              <h3>Send us a Message</h3>
              <p>Fill out the form below and we'll get back to you within 24 hours</p>
              
              {isSubmitted ? (
                <div className="success-message">
                  <div className="success-icon">✅</div>
                  <h4>Thank you for your message!</h4>
                  <p>We'll get back to you shortly.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter your full name"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="Enter your email"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter your phone number"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="company">Company</label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        placeholder="Enter your company name"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="service">Service Interest</label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                    >
                      <option value="">Select a service</option>
                      <option value="residential">Residential Solutions</option>
                      <option value="commercial">Commercial Systems</option>
                      <option value="industrial">Industrial Monitoring</option>
                      <option value="agriculture">Agriculture Solutions</option>
                      <option value="consultation">Free Consultation</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Tell us about your water monitoring needs..."
                    ></textarea>
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="btn btn-primary">
                      Send Message
                    </button>
                    <p className="form-note">
                      * Required fields. We respect your privacy and never share your information.
                    </p>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
